import React from 'react';

/**
 * Thin-stroke icons for the customer marketing shell.
 * Presentation only — not a service catalogue.
 */
const PATHS = {
  bolt: 'M13 2L4.5 13.5H11L10 22l9.5-12.5H13L13 2z',
  clock: 'M12 7v5l3 2',
  calendar: 'M7 3v3M17 3v3M4 8h16',
  shield: 'M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z',
  pin: 'M12 21s6-5.2 6-10a6 6 0 10-12 0c0 4.8 6 10 6 10z',
  search: 'M11 18a7 7 0 100-14 7 7 0 000 14zM20 20l-3.5-3.5',
  star: 'M12 3.5l2.2 4.6 5 .7-3.6 3.5.9 5.1L12 15.8 7.5 17.4l.9-5.1L4.8 8.8l5-.7L12 3.5z',
};

export default function FxGlyph({ name = 'bolt', className = 'fx-glyph' }) {
  const extra = PATHS[name];
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {name === 'bolt' && <path d={extra} />}
      {name === 'clock' && (
        <>
          <circle cx="12" cy="12" r="8" />
          <path d={extra} />
        </>
      )}
      {name === 'calendar' && (
        <>
          <rect x="4" y="5" width="16" height="15" rx="2" />
          <path d={extra} />
        </>
      )}
      {name === 'shield' && <path d={extra} />}
      {name === 'pin' && (
        <>
          <path d={extra} />
          <circle cx="12" cy="11" r="1.6" />
        </>
      )}
      {name === 'search' && <path d={extra} />}
      {name === 'star' && <path d={extra} />}
      {name === 'plumbing' && (
        <path d="M14.7 6.3a1 1 0 010 1.4l-1.2 1.2 2.6 2.6 1.2-1.2a1 1 0 011.4 1.4l-1.8 1.8a2 2 0 01-2.8 0l-.4-.4-4.2 4.2a2 2 0 01-2.8 0l-.6-.6a2 2 0 010-2.8l4.2-4.2-.4-.4a2 2 0 010-2.8l1.8-1.8a1 1 0 011.4 0z" />
      )}
      {name === 'electrical' && (
        <path d="M13 2L4.5 13.5H11L10 22l9.5-12.5H13L13 2z" />
      )}
      {name === 'ac' && (
        <>
          <path d="M12 3v18M4.5 7.5l15 9M4.5 16.5l15-9" />
          <circle cx="12" cy="12" r="2.2" />
        </>
      )}
      {name === 'cleaning' && (
        <>
          <path d="M12 3l1.2 3.2L16.5 7.5 13.2 8.7 12 12l-1.2-3.3L7.5 7.5l3.3-1.3L12 3z" />
          <path d="M18 13l.7 1.8 1.8.7-1.8.7L18 18l-.7-1.8-1.8-.7 1.8-.7L18 13z" />
          <path d="M6.5 14l.6 1.4 1.4.6-1.4.6-.6 1.4-.6-1.4-1.4-.6 1.4-.6.6-1.4z" />
        </>
      )}
      {name === 'pest' && (
        <>
          <ellipse cx="12" cy="14" rx="4.2" ry="5" />
          <circle cx="12" cy="7.5" r="2.2" />
          <path d="M8.2 10.5L5 8M15.8 10.5L19 8M8 14H4.5M16 14h3.5M8.5 17.5L5.5 20M15.5 17.5l3 2.5" />
        </>
      )}
      {name === 'paint' && (
        <>
          <path d="M4 16c0-2 2-3 4-3h8a3 3 0 003-3V5H8v5" />
          <path d="M8 16v2a2 2 0 11-4 0v-2" />
        </>
      )}
      {name === 'moving' && (
        <>
          <path d="M3 8l9-4 9 4-9 4-9-4z" />
          <path d="M3 8v8l9 4 9-4V8" />
          <path d="M12 12v8" />
        </>
      )}
      {name === 'appliance' && (
        <>
          <circle cx="12" cy="12" r="3" />
          <path d="M12 3v2.2M12 18.8V21M3 12h2.2M18.8 12H21M5.6 5.6l1.6 1.6M16.8 16.8l1.6 1.6M18.4 5.6l-1.6 1.6M7.2 16.8l-1.6 1.6" />
        </>
      )}
      {name === 'home' && (
        <>
          <path d="M4 11l8-7 8 7" />
          <path d="M6 10.5V20h12v-9.5" />
        </>
      )}
    </svg>
  );
}

export function glyphForService(service) {
  const slug = String(service?.slug || service?.id || service?.name || '').toLowerCase();
  if (slug.includes('plumb')) return 'plumbing';
  if (slug.includes('electric')) return 'electrical';
  if (slug.includes('ac') || slug.includes('air')) return 'ac';
  if (slug.includes('clean')) return 'cleaning';
  if (slug.includes('pest')) return 'pest';
  if (slug.includes('paint')) return 'paint';
  if (slug.includes('mov')) return 'moving';
  if (slug.includes('appliance')) return 'appliance';
  return 'home';
}
